<template>
  <div>
    <div v-if="carregando == true" class="carregando">
      <img width="130px" :src="iconeCarregando" />
      <br />
      <br />Carregando...
    </div>
    <div :class="`${insideLogin || insideBox ? '' : 'container'}`">
      <form ref="form" role="form" @submit.stop.prevent="onSubmit">
        <div v-if="!insideLogin" class=" mb-2">
          <h3 class="mt-3 text-white" v-if="isUpdate == false">
            Crie sua conta
          </h3>
          <h3 class="mt-3 text-center title" v-else>Dados Cadastrais</h3>
        </div>
        <div id="inputs " class="form-transparent ">
          <div class="row">
            <div class="col-sm-12 col-lg-12 mt-2">
              <fg-input
                label="Nome"
                name="Nome"
                v-model="form.nome"
                v-validate="{ required: true }"
                :state="validateState('Nome')"
                :class="validateClass('Nome')"
              ></fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12 col-lg-12 mt-2">
              <fg-input
                name="Email"
                v-model="form.email"
                label="Email"
                :state="validateState('Email')"
                :class="validateClass('Email')"
                v-validate="{ required: true, email: true }"
              ></fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12 col-lg-12 mt-2">
              <fg-input
                name="Celular"
                label="Celular"
                v-model="form.celular"
                v-validate="{ required: true }"
                :state="validateState('Celular')"
                :class="validateClass('Celular')"
                v-mask="'(##) #####-####'"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12 col-lg-12 mt-2">
              <fg-input
                size="large"
                class="w-full"
                name="CPF"
                id="CPF"
                label="CPF"
                v-model="form.cpf"
                v-validate="{ required: true }"
                :state="validateState('CPF')"
                :class="validateClass('CPF')"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
                v-mask="'###.###.###-##'"
                :disabled="isUpdate"
              />
            </div>
          </div>

          <div class="row" v-if="isUpdate">
            <div class="col-sm-12 col-lg-12 mt-2 ">
              <n-radio v-model="form.sexo" label="M">
                <div class="text-justify ">
                  Masculino
                </div>
              </n-radio>
              <n-radio v-model="form.sexo" label="F">
                <div class="text-justify ">
                  Feminino
                </div>
              </n-radio>
            </div>
          </div>

          <div class="row mt-3" v-if="isUpdate">
            <div class="col-sm-12 col-lg-12 mt-2">
              <fg-input
                size="large"
                class="w-full"
                name="Data de Nascimento"
                id="Data de Nascimento"
                label="Data de Nascimento"
                v-model="form.dtNascimento"
                v-validate="{ required: true, date_format: 'dd/MM/yyyy' }"
                :state="validateState('Data de Nascimento')"
                :class="validateClass('Data de Nascimento')"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
                v-mask="'##/##/####'"
              />
            </div>
          </div>

          <div class="row" v-if="!isUpdate">
            <div class="col-sm-12 col-lg-12 mt-2">
              <fg-input
                size="large"
                class="w-full"
                name="Cupom"
                id="Cupom"
                label="Possui Cupom? Não é Obrigatório"
                v-model="form.cupom"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
                placeholder="CUPOM"
                @blur="validaCupom()"
                @keyup.native="mascaraCupom($event)"
              />
              <div class="text-success text-center" v-if="textoCupom">
                {{ textoCupom }}
              </div>
            </div>
          </div>

          <div class="row" v-if="!isUpdate">
            <div class="col-sm-12 col-lg-12 mt-2">
              <label>Senha</label>
              <password
                v-model="form.senha"
                id="Senha"
                v-popover:popovertrigger
                name="Senha"
                placeholder="Senha"
                defaultClass="form-control p-2 pl-3"
                :secureLength="2"
                :badge="false"
                v-validate="{ required: true }"
                :state="validateState('Senha')"
                :class="validateClass('Senha')"
                :toggle="true"
                @score="showScore"
              />
              <el-popover
                ref="popovertrigger"
                trigger="click"
                popper-class="popover popover-primary"
                placement="top"
              >
                <h3 class="popover-header">Requisitos Mínimos</h3>
                <div class="popover-body">
                  8 caracteres entre letras, números e símbolos
                </div>
              </el-popover>
            </div>
          </div>

          <div v-if="!isUpdate" class=" mt-1 text-right">
            Já tem uma conta?
            <router-link
              v-if="!insideLogin"
              class=""
              style="text-decoration:underline"
              to="/Login"
              >Entrar</router-link
            >
            <a
              v-else
              class=""
              style="text-decoration:underline"
              @click="emitRetorno()"
              href="javascript:void(0)"
              >Entrar</a
            >
          </div>

          <div class="row mt-3">
            <div class="col-sm-12 col-lg-12">
              <n-button
                v-if="!isUpdate"
                nativeType="submit"
                class="btn-block  btn-primario-formulario"
                type="success"
                >Criar Conta</n-button
              >

              <div class="text-right">
                <n-button
                  v-if="isUpdate"
                  nativeType="submit"
                  class="btn-primario-formulario"
                  type="success"
                  >Salvar</n-button
                >
              </div>

              <errosAlert
                :exibeErro="exibeErro"
                :msgErro="msgErro"
                :listaErro="$validator.errors.all()"
              ></errosAlert>

              <div v-if="!isUpdate" class=" my-5">
                Ao clicar em Criar Conta, você concorda com nossos
                <router-link
                  class=""
                  style="text-decoration:underline"
                  to="/TermosDeUso"
                  >Termos de Uso</router-link
                >
                e
                <router-link
                  class=""
                  style="text-decoration:underline"
                  to="/PoliticaDePrivacidade"
                  >Politica de Privacidade</router-link
                >.
              </div>
            </div>
          </div>

          <!--div class="row" v-if="isUpdate==true">
            <div class="col-sm-12 col-lg-12 mt-2  text-right">
              <div v-if="!dados.dataDesativada" class="alert alert-warning">
                <center>Caso deseje desativar sua conta VetMark clique no botão abaixo. Você poderá reativar sua conta a qualquer momento efetuando login e clicando em REATIVAR.</center>
                <br />
                <n-button
                  v-if="!dados.dataDesativada"
                  @click="desativar()"
                  nativeType="button"
                  round
                  type="danger"
                >Desativar</n-button>
              </div>

              <n-button v-else @click="reativar()" nativeType="button" round type="success">Reativar</n-button>
            </div>
          </div-->
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import {
  Button,
  Checkbox,
  Radio,
  FormGroupInput,
  Slider,
  Switch,
  Alert,
  Modal,
} from '@/components';

import { Popover, DatePicker } from 'element-ui';

import Password from 'vue-password-strength-meter';

import service from './../../services';
import cpfCnpj from './../../services/cpfCnpj';
import celular from './../../services/celular';
import errosAlert from './errosAlert';
import swal from 'sweetalert';
import jwt from 'jsonwebtoken';
import locale from './../../locale';
import storage from '../../services/storage';
import { KEY_LOCAL_STORAGE } from './../../const';
import dataFunctions from '../../services/dateConversion';

export default {
  components: {
    Password,
    errosAlert,
    Alert,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [Radio.name]: Radio,
    [FormGroupInput.name]: FormGroupInput,
    [Switch.name]: Switch,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Popover.name]: Popover,
    Slider,
    Modal,
  },
  props: ['dados', 'interno', 'insideBox', 'insideLogin'],
  data() {
    return {
      dataFunctions,
      iconeCarregando: service.getEnvIconeCarregando(),
      score: 0,
      codPerfilAux: null,
      showModal: false,
      showModal2: false,
      carregando: false,
      especialidades: [],
      textoCupom: null,
      exibeErro: false,
      msgErro: '',
      isUpdate: false,
      decoded: null,
      form: {
        cpf: null,
        nome: null,
        email: null,
        celular: null,
        senha: null,
        cupom: null,
        idPerfil: 2,
        ip: null,
        uid: null,
        userAgent: null,
        fbc: null,
        sexo: null,
        dtNascimento: null,
      },
      radios: {
        radioOn: '2',
        radioOff: '2',
      },
      checkboxes: [],
      switches: {
        defaultOn: true,
        defaultOff: false,
      },
      sliders: {
        simple: 30,
        rangeSlider: [20, 60],
      },
    };
  },
  methods: {
    mascaraCupom(event) {
      const input = event.target;
      input.value = input.value
        .replace(new RegExp(' ', 'g'), '-')
        .toUpperCase();
    },
    disparaEventoFaceCadastro() {
      window.fbq('track', 'CompleteRegistration');
    },
    validaCupom() {
      //this.carregando = true;
      if (this.form.cupom)
        service
          .post('Cupom', 'ValidarCupom', { cupom: this.form.cupom })
          .then(res => {
            this.carregando = false;
            this.form.idCupom = res.data.idCupom;
            this.form.valorCredito = res.data.valorCredito;
            this.textoCupom = `Cupom válido, você receberá R$ ${res.data.valorCredito.toFixed(
              2,
            )} de crédito para começar abrir seus boxes`;
          })
          .catch(error => {
            console.log(error);
            this.exibeErro = true;
            this.msgErro = ' ' + error;
            this.carregando = false;
            swal('ops!', this.msgErro, 'error');
            this.showModal = false;
            this.textoCupom = null;
            this.form.idCupom = null;
            this.form.valorCredito = null;
          });
    },
    verificaDecoded() {
      const token = storage.lerStorage(KEY_LOCAL_STORAGE.USER_TOKEN);

      if (token) {
        this.decoded = jwt.decode(token);
      }
    },
    desativar() {
      this.showModal = true;
    },
    reativar() {
      this.showModal2 = true;
    },
    showFeedback({ suggestions, warning }) {
      console.log('🙏', suggestions);
      console.log('⚠', warning);
    },
    showScore(score) {
      this.score = score;
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (this.veeFields[ref]) {
        if (this.veeFields[ref].dirty) {
          if (this.veeFields[ref].valid == false) {
            return 'has-danger';
          } else {
            return 'has-success';
          }
        }
      }
      return null;
    },
    async preencheForm() {
      this.form.ip = await service.getIP();
      if (this.interno) {
        this.isUpdate = true;
        this.verificaDecoded();
        this.buscaDados();
      }
    },
    resetForm() {
      return new Promise(resolve => {
        this.form = {
          cpf: null,
          nome: null,
          email: null,
          celular: null,
          senha: null,
        };
        this.$nextTick(() => this.$validator.reset());
        resolve();
      });
    },
    buscaDados() {
      service
        .post('Usuario', 'Buscar', { idUsuario: this.decoded.idUsuario })
        .then(res => {
          this.carregando = false;
          this.form.idUsuario = res.data[0].idUsuario;
          this.form.nome = res.data[0].nome;
          this.form.celular = res.data[0].celular;
          this.form.email = res.data[0].email;
          this.form.cpf = res.data[0].cpf;
          this.form.sexo = res.data[0].sexo;
          if (res.data[0].dataNascimento) {
            this.form.dataNascimento = dataFunctions.converteISOToDate(
              res.data[0].dataNascimento,
            );
            this.form.dtNascimento = dataFunctions.converteISOToDate(
              res.data[0].dataNascimento,
            );
          }
        })
        .catch(error => {
          console.log(error);
          this.exibeErro = true;
          this.msgErro = ' ' + error;
          this.carregando = false;
          swal('ops!', this.msgErro, 'error');
          this.showModal = false;
        });
    },

    desativarGeral() {
      service
        .put('Usuario', this.dados.idUsuario + '/ativar-desativar', {})
        .then(() => {
          this.carregando = false;
          this.exibeErro = false;
          swal('', 'Conta desativada com sucesso!', 'success').then(okay => {
            if (okay) {
              window.location.reload();
            }
          });

          this.showModal = false;
        })
        .catch(error => {
          console.log(error);
          this.exibeErro = true;
          this.msgErro = ' ' + error;
          this.carregando = false;
          swal('ops!', this.msgErro, 'error');
          this.showModal = false;
        });
    },
    reativarGeral() {
      service
        .put('Usuario', this.dados.idUsuario + '/ativar-desativar', {})
        .then(() => {
          this.carregando = false;
          this.exibeErro = false;
          swal('', 'Conta reativada com sucesso!', 'success').then(okay => {
            if (okay) {
              window.location.reload();
            }
          });

          this.showModal2 = false;
        })
        .catch(error => {
          console.log(error);
          this.exibeErro = true;
          this.msgErro = 'Não foi possível atualizar, ' + error;
          this.carregando = false;
          swal('ops!', this.msgErro, 'error');
          this.showModal2 = false;
        });
    },
    getFbClientId() {
      let result = /_fbp=(fb\.1\.\d+\.\d+)/.exec(window.document.cookie);
      if (!(result && result[1])) {
        return null;
      }
      return result[1];
    },
    getFbc() {
      const fbclid = storage.lerStorage(KEY_LOCAL_STORAGE.FBCLID);
      let fbc = null;
      if (fbclid) fbc = 'fb.1.' + Date.now().toString() + '.' + fbclid;

      return fbc;
    },
    onSubmit() {
      let uid = storage.lerStorage(KEY_LOCAL_STORAGE.UID);
      if (uid) {
        this.form.uid = uid;
      }

      this.$validator.validateAll().then(result => {
        //const verificaEspaco = () => /\s/g.test(this.form.nome);
        if (this.form.nome) {
          let splitNome = this.form.nome.split(' ');
          if (splitNome.length == 1) {
            this.exibeErro = true;
            this.msgErro = 'Insira o seu Nome e sobrenome';
            return;
          } else {
            if (splitNome[1] == '') {
              this.exibeErro = true;
              this.msgErro = 'Insira o seu Nome e sobrenome';
              return;
            }
          }
        }

        if (this.form.cpf) {
          if (cpfCnpj.valida_cpf_cnpj(this.form.cpf) == false) {
            this.exibeErro = true;
            this.msgErro = 'Esse CPF não é válido';
            return;
          } else {
            this.exibeErro = false;
            this.msgErro = '';
          }
        }

        if (this.form.celular) {
          if (celular.verificaCelular(this.form.celular) == false) {
            this.exibeErro = true;
            this.msgErro = 'Esse celular não é válido';
            return;
          } else {
            this.exibeErro = false;
            this.msgErro = '';
          }
        }

        if (this.form.cnpj)
          if (cpfCnpj.valida_cpf_cnpj(this.form.cnpj) == false) {
            this.exibeErro = true;
            this.msgErro = 'Esse CNPJ não é válido';
            return;
          } else {
            this.exibeErro = false;
            this.msgErro = '';
          }

        if (!this.isUpdate)
          if (this.score < 2 && this.isUpdate == false) {
            this.exibeErro = true;
            this.msgErro =
              'Sua senha não atingiu os requisitos mínimos de segurança (8 caracteres entre letras, números e símbolos )';

            return;
          } else {
            this.exibeErro = false;
            this.msgErro = '';
          }

        if (this.isUpdate) {
          if (!this.form.sexo) {
            this.exibeErro = true;
            this.msgErro = 'Selecione Sexo Masculino ou Feminino';

            return;
          }
        }

        if (result) {
          this.carregando = true;

          this.form.codPerfil = this.codPerfil;
          this.form.fbClientId = this.getFbClientId();
          this.form.userAgent = navigator.userAgent;
          this.form.fbc = this.getFbc();

          if (this.form.dtNascimento) {
            this.form.dataNascimento = dataFunctions.convertDateToISO(
              this.form.dtNascimento,
            );
          }

          if (!this.isUpdate) {
            service
              .post('Usuario', 'Adicionar', this.form)
              .then(res => {
                this.carregando = false;
                this.exibeErro = false;

                this.resetForm();
                swal(
                  '',
                  'Conta criada com sucesso! Adicione Créditos e abra seus boxes.',
                  'success',
                );
                this.disparaEventoFaceCadastro();
                this.exibeErro = false;
                storage.escreveStorage(
                  KEY_LOCAL_STORAGE.USER_TOKEN,
                  res.data.token,
                );
                storage.escreveStorage(KEY_LOCAL_STORAGE.SALDO, res.data.s);
                if (!this.insideLogin) {
                  this.$router.push(`/saldoInterno`);
                } else this.$emit('CadastroConcluido', 'Cadastro');
              })
              .catch(error => {
                console.log(error);
                this.exibeErro = true;
                this.msgErro = 'Não foi possível criar Conta, ' + error;
                this.carregando = false;
                swal('ops!', this.msgErro, 'error');
              });
          } else {
            delete this.form.fbClientId;
            service
              .put('Usuario', `Atualizar/${this.decoded.idUsuario}`, this.form)
              .then(() => {
                this.carregando = false;
                this.exibeErro = false;
                swal('', 'Dados Atualizados com Sucesso.', 'success');
              })
              .catch(error => {
                console.log(error);
                this.exibeErro = true;
                this.msgErro = 'Não foi possível Atualizar Dados, ' + error;
                this.carregando = false;
                swal('ops!', this.msgErro, 'error');
              });
          }
        }
      });
    },
    emitRetorno() {
      this.$emit('returnLogin');
    },
  },
  mounted() {
    this.$validator.localize('ptBr', locale);
    this.preencheForm();
  },
};
</script>
<style scoped>
select {
  padding: 10px !important;
}
input[type='radio'],
input[type='checkbox'] {
  margin-right: 10px !important;
}
.btnbuscar {
  font-size: 24px;
  text-transform: uppercase;
  color: #094049;
}
.Teste {
  background-color: #ffffff;
  border: 1px solid #e3e3e3;
  border-radius: 30px !important;
  color: #2c2c2c !important;
  line-height: normal;
  font-size: 0.8571em !important;
  height: 100%;
}
</style>
<style>
.cardCadastro .form-check .form-check-sign::after {
  color: #fff;
}
</style>
